export default __webpack_public_path__ + "static/media/news31.9e0c85d7.jpg";